export const it_mapping = {
    title: 'Mappature',
    body: 'Puoi mappare subito gli immobili di tutti i comuni italiani ed individuare velocemente i <b>“don’t wanter”</b> e le operazioni da approfondire.',
    button: 'Crea e Gestisci',
    label_modal_building: 'DETTAGLIO IMMOBILE',
    label_data_entry: 'Dati mappatura',
    label_address: 'Indirizzo',
    label_image: 'Immagine',
    label_mq: 'Mq',
    label_price: 'Prezzo',
    label_room: 'Vani',
    label_floor: 'Piano',
    label_lift: 'Ascensore?',
    label_bathroom: 'n. Bagni',
    label_renovation: 'Da ristrutturare?',
    label_date: 'Data',
    label_link: 'Link',
    label_note: 'Note',
    table_title: 'Tabella immobili mappati',
    table_floor: 'Piani',
    table_address: 'Indirizzo',
    table_room: 'Vani',
    table_mq: 'Mq.',
    table_price: '€ (€/mq)',
    table_deviation: 'Scost. %',
    table_archive_title: 'Archivio Mappature',
    table_archive_city: 'Città',
    table_archive_mapped_zone: 'Zone mappate',
    table_zone: 'Zona',
    table_macrozone: 'Macro Zona',
    table_microzone: 'Micro Zona',
    show_link: 'Mostra mappatura',
    hide_link: 'Nascondi',
    free_market:'Mercato Libero',
    add_new_item:'Nuovo Immobile',
    indifferente:'indifferente',
    totale_immobili:'Totale Immobili',
    button_import:'Importa nella tabella gli immobili selezionati',
    fltra:'Filtra e seleziona gli immobili da importare nella tabella',
    popover_zone_title: 'Pronto per iniziare!',
    popover_zone_content: '<p>Questa card è il punto di partenza per generare la tua mappatura su una determinata area.\n' +
        'Inserisci città, zona, macrozona e microzona ed incomincia ad inserire gli immobili.</p>',
    alert_end:'OOOPS! Hai esaurito le ricerche GIORNALIERE per il tuo pacchetto Real Estate Pro.',
    popover_list_title: 'Elenco degli immobili',
    popover_list_content: '<p>Adesso puoi inserire gli immobili cliccando su "Importazione manuale" oppure su "Disegna la mappa". ' +


        'Il sistema genererà in automatico la percentuale di scostamento con il colore associato. Ricorda che occorre approfondire gli annunci immobiliari con un\'alta percentuale di scostamento in negativo rispetto allo street price.' +
        '</p>' +
        '<p><span class="abtg__dot abtg__dot-yellow">giallo: da 0 a 10</span> | <span class="abtg__dot abtg__dot-green">verde: da -30 a 0</span> </p>' +
        '<p><span class="abtg__dot abtg__dot-blue">Blu: inferiore a -30</span> | <span class="abtg__dot abtg__dot-black">nero: oltre 10</span></p>' +
        '<p>Qualora decidessi di approfondire l’operazione - ad immobile inserito - puoi cliccare l’icona <i class="fas fa-calculator abtg__fontIcon" style="font-size:140%!important;"></i> per accedere alla scheda dell’operazione e al conto economico. </p>',

    popover_archive_title: 'Il tuo archivio',
    popover_archive_content:
        '<p>In questa card puoi selezionare e gestire le mappature create in base alla regione selezionata sulla mappa.</p>\n',



    popover_scan_title: 'Scan di mercato',
    popover_scan_content: '<p>Attraverso lo Scan di Mercato è sufficiente incollare l\'indirizzo del risultato di ricerca di immobiliare.it nell\'apposito campo". ' +



        '<p>Real Estate Pro eseguirà la medesima ricerca (comprensiva di filtri) direttamente su uno dei due portali.<br>N.b. Lo scan di mercato è attivo solo su immobiliare.it </p>',

    cancellare_disegno:'CANCELLA IL DISEGNO',
    cerca:'CERCA IMMOBILI',
    imm_rimanenti:'Immobili mensili rimanenti',
    agg_rimanenti:'Aggiornamenti zona mensili rimanenti',
    residenziali:'Immobili residenziali',
    commericali:'Immobili commerciali',
    zone_title:'Zone',
    first_folder:'Cartella Principale',
    move:'Sposta le zone selezionate in..',
    add_folder:'Aggiungi Cartella..',
    folder:'Cartella:',
    folder_delete_title:'CANCELLA QUESTA CARTELLA',
    folder_delete_h3:'Sei sicuro di voler eliminare questa Cartella?',
    folder_delete_h5:'Tutte le zone contenute in essa toneranno nella cartella Principale',
    folder_delete_no:'No, ci ho ripensato',
    folder_delete_si:'Elimina',
    folder_edit_title:'AGGIORNA IL NOME DELLA CARTELLA',
    folder_create_title:'CREA NUOVA CARTELLA',
    folder_create_name:'Nome della cartella:',
    folder_edit_name:'Nuovo Nome:',
    folder_create_error:'Inserisci un nome valido',
    folder_create:'Crea Cartella',
    folder_edit:'Aggiorna',
    tutte_le_zone: 'Vedi tutte le zone mappate',
    link_modifica_dati_zona: 'Modifica dati zona',
    link_aggiorna_mappa: 'Aggiorna mappa',
    link_chiudi_info: 'Chiudi tutte le info',
    link_cancella_zona: 'Cancella zona',
    link_nuova_mappatura: 'Nuova mappatura',
    text_no_mappatura: 'Per questa zona non è stata tracciato alcun poligono sulla mappa.',
    text_crea_mappa: 'crea la mappa.',
    link_immobili_residenziali: 'Immobili residenziali',
    link_immobili_commerciali: 'Immobili commerciali',
    text_media_prezzo: 'Media prezzo/mq',
    text_ricalcolo: 'Ricalcolo lo scostamento',
    link_esporta_excel: 'Esporta Excel',
    link_carica_immobile: 'Carica immobile',
    link_controlla_annunci: 'Controlla annunci scaduti',
    link_ricalcola_scostamento: 'Ricalcola scostamento',
    text_sto_controllando: 'controlla gli annunci scaduti direttamente aggiornando la mappa',
    link_cancella: 'Cancella gli annunci non più presenti',
    link_modifica: 'Modifica',
    link_conto: 'Conto Economico',
    link_cancella_stop: 'Cancella',
    ristrutturazione: 'ristrutturazione',
    warning: 'Attenzione! Questo annuncio non è più presente sul portale',
    link_vai_annuncio: 'Vai all\'annuncio',
    text_tipologia_immobile: 'Tipologia immobile',
    check_residenziale: 'Resid.',
    check_commerciale: 'Comm.',
    domanda_rinnovato: 'rinnovato?',
    bottone_salva: 'SALVA',
    label_check_anomalo: 'controlla se annuncio valido',
    link_e_valido: 'clicca <br>se è ancora valido',
    doppione: 'Immobile doppione. Questo immobile è risultato simile ad un altro immobile presente nella ricerca.',
    doppione_vai: 'Vai all\'immobile simile!',
    probabile_doppione: 'PROBABILE IMMOBILE DOPPIONE!',
    non_e_doppione: 'Non è doppione.',
    elimina_doppione: 'Elimina doppione',
    immobile_gia_importato: 'Immobile già importato. Se lo importi nuovamente,\n' +
        '                            aggiornerà quello esistente.',
    prezzo_diverso: ' Il prezzo dell\'immobile già importato è',
    diverso: 'DIVERSO',
    lostesso: 'LO STESSO',
    vai_al_dettaglio: 'Vai al dettaglio su',
    ristrutturato_si: 'Ristrutturati "sì"',
    ristrutturato_ni: 'Ristrutturati "nì"',
    ristrutturato_no: 'Ristrutturati "no"',
    azzera_filtri: 'Azzera filtri'
};
